import { render, staticRenderFns } from "./ItemRenderer.vue?vue&type=template&id=71cf6ada&"
import script from "./ItemRenderer.vue?vue&type=script&lang=ts&"
export * from "./ItemRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports